export default __webpack_public_path__ + "static/media/csango10-13kerulet-elado-lakasok-1.5dd42dde.webp";